/* eslint-disable react/prop-types */
import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import "./style.css";
import { ErrorMessage } from "formik";
import { MdErrorOutline } from "react-icons/md";

const RichTextEditor = ({
  title,
  name,
  requiredField,
  setFieldValue,
  placeholder,
  errors,
  values,
  withFormik = true,
}) => {
  const handleEditorChange = (content) => {
    setFieldValue(name, content);
  };

  return (
    <div style={{ padding: "0px" }}>
      <label
        htmlFor={name}
        className="block leading-6 text-gray-500 mb-1 text-sm"
      >
        {title}
        {requiredField && <span className="text-red-800 mx-1">*</span>}
      </label>
      <ReactQuill
        value={values[name] || ""}
        onChange={handleEditorChange}
        className="quill-editor"
        placeholder={placeholder}
        modules={{
          toolbar: [
            [{ list: "ordered" }, { list: "bullet" }],
            ["bold"],
            ["link"],
          ],
        }}
        formats={[
          "header",
          "font",
          "size",
          "bold",
          "strike",
          "blockquote",
          "list",
          "indent",
          "link",
          "color",
          "background",
          "align",
        ]}
      />

      {withFormik && (
        <ErrorMessage name={name}>
          {(msg) => (
            <div className="text-xs text-red-500 text-left w-full flex gap-1 items-center mt-1">
              <MdErrorOutline size={16} />
              <p className="text-xs">{msg}</p>
            </div>
          )}
        </ErrorMessage>
      )}
    </div>
  );
};

export default RichTextEditor;
